<template>
  <div ref="scroller" class="message-list">
    <div v-for="(message, index) in messages" v-bind:key="message.id">
      <MessageItem
        :message="message"
        :is-answering="isAnsweringMsg(message, index)"
        :is-loading="isLoadingMsg(message, index)"
        :full-screen-mode="fullScreenMode"
        @toast="setToast"
      />
    </div>
    <div class="message-list-header">
      <div class="intro">
        <div class="intro-text">
          <div class="title">
            <h1>UX GPT</h1>
            <i class="icon icon--beta-text"></i>
          </div>
          <p class="description">All Set! Get Deeper Insights with UX GPT!</p>
        </div>
        <i class="icon icon--becle-img"></i>
      </div>
    </div>
    <div class="toast" v-show="toastMsg">{{ toastMsg }}</div>
  </div>
</template>

<script>
import MessageItem from './MessageItem.vue'

export default {
  name: 'MessageList',
  components: {
    MessageItem
  },

  props: {
    messages: Array,
    isLoading: Boolean,
    isAnswering: Boolean,
    fullScreenMode: Boolean
  },

  data () {
    return {
      scroller: null,
      toastMsg: ''
    }
  },
  methods: {
    isLoadingMsg (msg, index) {
      return this.isLoading && index === 0 && msg.role === 'ai'
    },
    isAnsweringMsg (msg, index) {
      return this.isAnswering && index === 0 && msg.role === 'ai'
    },
    handleClickQuestion (question, idx) {
      const questionData = {
        prompt: question,
        fixedAnswer: idx
      }
      this.$emit('submit', questionData)
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    setToast (msg) {
      this.toastMsg = msg
      setTimeout(() => {
        this.toastMsg = ''
      }, 2000)
    },
    scrollToBottom () {
      this.$refs.scroller.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.message-list {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  max-height: 100%;
  overflow-y: auto;

  .toast {
    @include flexXYcenter;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 32px;
    padding: 6px 16px;
    border-radius: 6px;
    background-color: #000;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
    font-size: 13px;
    font-weight: 400;
    line-height: 1.2;
    color: #fff;
    box-sizing: border-box;
    z-index: 10;
  }

  &-header {
    padding: 33px 0 28px;
    margin: 0 40px;
    border-bottom: 1px solid #BDBDBD;
    .intro {
      display: flex;
      gap: 25px;
      align-items: flex-end;
      &-text {
        .title {
          display: flex;
          gap: 2px;
          align-items: flex-end;
          margin-bottom: 4px;
          h1 {
            color: $brandColor;
            font-family: "rubrik-new";
            font-size: 58px;
            font-weight: 800;
          }
          .icon--beta-text {
            padding-bottom: 9px;
          }
        }
        .description {
          padding-left: 2px;
          color: #888;
          font-size: 26px;
          font-weight: 600;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .message-list {
    //   스크롤 바 커스텀 - WebKit 기반 브라우저 (Chrome, Edge, Opera, Safari, ios)
    &::-webkit-scrollbar {
      width: 22px;
    }

    &::-webkit-scrollbar-thumb {
      height: 30%;
      background: #C3C3C3;
      border-radius: 16px;
      border: 7px solid #ECECEC;
    }

    &::-webkit-scrollbar-track {
      background: none;
    }
  }
}

@media (max-width: 768px) {
}

@media (max-width: 460px) {
}
</style>
